/**
 * @typedef {import('antd').SelectProps} SelectProps
 */

/**
 * @typedef { Object } CustomSelectProps
 * @property { React.component } [prefixIcon] Optional property to show a prefix icon
 */

import React from 'react';

import { Select as SelectCore } from 'antd';
import cx from 'classnames';

import styles from './Select.module.scss';
/**
 * @description UI Component to display the select form element. Underlying it is using the antd select component.
 *
 * @author  Hemant Kumar Goyal <@hemantkumar.goyal>
 *
 * @reference https://ant.design/components/select
 *
 * @param {SelectProps & CustomSelectProps}  props https://ant.design/components/select
 *
 * @returns {React.component}
 */

const Select = (props) => {
	const { children = null, prefixIcon, classes = {}, ...restProps } = props;
	return (
		<div
			className={cx(styles.selectWrapper, classes.selectWrapper, {
				[styles.withPrefixIcon]: prefixIcon,
			})}
		>
			{prefixIcon && <div className={styles.prefixIcon}>{prefixIcon}</div>}
			<SelectCore {...restProps}>{children}</SelectCore>
		</div>
	);
};

export default Select;
